import React from 'react';
import { ArchiveDetailsResponse, RepoItem } from '../../autogenerated/ZoomBridge';
import t from '../../i18n/I18n';
import ArchiveDetails_Query from '../../queries/archive-details/ArchiveDetails_Query';
import { getErrorMessage } from '../../util/ErrorUtil';
import Modal2 from '../Modal2';

type props = {
  assets: Array<RepoItem>,
  onClose: function
};

type state = {
  message: string
};

class ArchiveDetailsModal extends React.Component<props, state> {
  constructor(props) {
    super(props);
    this.state = {
      message: ''
    };
    const assets: Array<RepoItem> = this.props.assets;
    const archiveDetails_Query: ArchiveDetails_Query = new ArchiveDetails_Query(assets);
    archiveDetails_Query.fetchArchiveDetails().then(
      (response: ArchiveDetailsResponse) => {
        this.setState({ message: response.getMessage() });
      },
      (err: Error) => {
        this.setState({ message: getErrorMessage(err) });
      }
    );
  }

  render() {
    const modalProps = {
      name: 'ArchiveDetailsDialog',
      title: t('ARCHIVE_DETAILS'),
      onClose: this.props.onClose,
      buttons: [{ label: t('CLOSE'), onClick: this.props.onClose, type: 'PRIMARY' }]
    };
    return (
      <Modal2 {...modalProps}>
        <div>{this.state.message}</div>
      </Modal2>
    );
  }
}
export default ArchiveDetailsModal;
